// auth.router.js - Authentication routes
import { requiresNoAuth, resetUser, checkUser } from '../middlewares/auth.validation.js';

export function getAuthRoutes(options = {}) {
  const route = options.route || 'Home';

  return {
    parentName: route,
    config: {
      basePath: 'auth',
      component: () => import(/* webpackChunkName: "auth-layout" */ '../components/layouts/Auth.vue'),
      meta: {
        layoutKey: 'auth',
        // Auth-экран — чистый холст: без хедера/футера/сайдбара приложения.
        // Наследуется всеми дочерними роутами (signin/signup/reset-password).
        header: null,
        footer: null,
        header_navigation: null,
        sidebar_navigation: null,
        sidebar_width_hidden: 'w-zero',
        title: {
          en: 'Аутентификация',
          ru: 'Authentication',
        },
      },
      routes: [
        {
          path: 'signin',
          name: 'Sign In',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: {
              en: 'Sign In',
              ru: 'Вход',
            },
          },
          component: () => import(/* webpackChunkName: "signin" */ '../components/pages/SignIn.vue'),
        },
        {
          path: 'reset-password',
          name: 'Reset Password',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: {
              en: 'Reset Password',
              ru: 'Сбросить Пароль',
            },
          },
          component: () => import(/* webpackChunkName: "reset-password" */ '../components/pages/ResetPassword.vue'),
        },
        {
          path: 'signup',
          name: 'Sign Up',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: {
              en: 'Sign Up',
              ru: 'Регистрация',
            },
          },
          component: () => import(/* webpackChunkName: "signup" */ '../components/pages/SignUp.vue'),
        },
        {
          path: 'invite',
          name: 'Invite',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: {
              en: 'Invite',
              ru: 'Приглашение',
            },
          },
          component: () => import(/* webpackChunkName: "signup" */ '../components/pages/Invite.vue'),
        },
      ],
    }
  };
}
